module.exports = __webpack_public_path__ + "static/media/emulsionssoftenersforTextile.d14aa327.png";